export default "__VITE_ASSET__MkG_q4ST__"